<template>
    <div>
        <h1 v-text="title"></h1>
        <!--<div class="category-description" v-html="description"></div>-->
    </div>
</template>

<script>
    import _ from 'lodash';
    import axios from 'axios';

    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    export default {
        data() {
            return {
                description: '',
                categories: [],
                fetched: {},
                title: 'Products'
            };
        },
        computed: {
            isBrand(){
                let path = window.location.pathname;
                return path.indexOf('brand') > -1;
            }
        },
        methods: {
            fetchDescription() {
                if (this.categories.length == 0) {
                    this.title = 'Products';
                    this.description = '';
                    return;
                }

                var tree = JSON.stringify(this.categories);

                if (this.fetched[tree]) {
                    let cached = this.fetched[tree];
                    this.description = cached.description;
                    this.title = cached.title;
                    return;
                }

                axios({
                    method: 'get',
                    url: '/actions/category-api-module/description/index',
                    params: {
                        tree_menu: tree
                    }
                })
                .then(response => {
                    this.description = response.data.description;
                    this.title = response.data.title;
                    this.fetched[tree] = response.data;
                })
                .catch(error => {
                });
            }
        },
        watch: {
            categories: {
                handler: function (after, before) {
                    if (!_.isEqual(before, after)) {
                        this.fetchDescription();
                    }
                },
                deep: true
            }

        },
    }

</script>
